export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8597.c2806023.jpg";